// Lightweight global toast bus. No context needed — call `toast.success(...)`
// from anywhere and the <ToastHost/> mounted in AppLayout renders them.
import { useEffect, useState } from 'react';
let toasts = [];
const listeners = new Set();
const notify = () => listeners.forEach((l) => l());
function push(kind, text, ttl = 4000) {
    const id = Date.now() + Math.random();
    toasts = [...toasts, { id, kind, text, ttl }];
    notify();
    if (ttl > 0) {
        setTimeout(() => {
            toasts = toasts.filter((t) => t.id !== id);
            notify();
        }, ttl);
    }
}
export const toast = {
    info: (text, ttl) => push('info', text, ttl),
    success: (text, ttl) => push('success', text, ttl),
    warning: (text, ttl) => push('warning', text, ttl),
    error: (text, ttl) => push('error', text, ttl ?? 6000),
    dismiss: (id) => { toasts = toasts.filter((t) => t.id !== id); notify(); },
};
export function useToasts() {
    const [, force] = useState(0);
    useEffect(() => {
        const l = () => force((n) => n + 1);
        listeners.add(l);
        return () => { listeners.delete(l); };
    }, []);
    return toasts;
}
